import {
  IEquipmentModel,
  TCreateEquipmentModelDTO,
} from '@/pages/Equipment/pages/EquipmentModels/equipmentModels.types.ts'
import SeparateLine from '@/shared/Forms/SeparateLine'
import FormField from '@/shared/Forms/FormField'
import TextInput from '@/shared/Inputs/TextInput'
import Button from '@/shared/Buttons/Button'
import useStateWithChange from '@/shared/hooks/useStateWithChange.ts'
import useEquipmentModel from '@/pages/Equipment/pages/EquipmentModels/hooks/useEquipmentModel.ts'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import equipmentModelsApi from '@/pages/Equipment/pages/EquipmentModels/equipmentModels.api.ts'
import equipmentEvents from '@/pages/Equipment/events/equipment/equipment.events.ts'

interface IProps {
  modelId: IEquipmentModel['id']
  onCancel: () => void
}

const EditEquipmentModelSidePageContent = (props: IProps) => {
  const { wait, loading } = useHttpLoader()

  const initialState = useEquipmentModel(props.modelId)
  const [model, _, handleChange] = useStateWithChange<TCreateEquipmentModelDTO>(initialState)

  const handleSave = () => {
    wait(equipmentModelsApi.updateModel(props.modelId, model), (resp) => {
      if (resp.status === 'success') {
        equipmentEvents.modelUpdated(resp.body)
        props.onCancel()
      }
    })
  }

  return (
    <div className="flex-lines gap16" style={{ height: '100%' }}>
      <h2 className="text-heading-4">Редактирование модели оборудования</h2>
      <SeparateLine />
      <FormField label="Наименование" required={true}>
        <TextInput value={model.name} name="name" onChange={handleChange} placeHolder="Введите наименование" />
      </FormField>

      <div style={{ marginTop: 'auto' }}>
        <SeparateLine />
      </div>
      <div className="inline-flex-gap gap8">
        <Button size="default" type="primary" text="Сохранить" onClick={handleSave} loading={loading} />
        <Button size="default" type="default" text="Отменить" onClick={props.onCancel} disabled={loading} />
      </div>
    </div>
  )
}

export default EditEquipmentModelSidePageContent
